<template>
  <div class="home">
    <h1 class="my-8" id="checkout">Checkout</h1>
    <h3>Deine Bestellung:</h3>
    <p>
      alsjkd
    </p>
  </div>
</template>
<script>
export default {

}

/*
  beforeMount () {
    paypal.Buttons({ // eslint-disable-line
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: this.purchaseUnits
        })
      },
      onApprove: function (data, actions) {
        alert('Danke für deine Bestellung! Wir melden uns bei dir, sobald sie in den Versand geht.')
      }
    }).render('#paypal')
  },
  computed: {
    purchaseUnits () {
      return this.stagedItems.map(item => ({
        description: item.description,
        amount: {
          currency_code: 'EUR',
          value: item.amount * item.price
        }
      }))
    }
  },
*/
</script>
